import { DataBean } from "../DataBean";

export class ProcessPropertiesItem extends DataBean {

    public async getProcessTypeConstants(arg: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProcessTypeConstants_Number", [arg]);
    }

    public async addProcessPropertiesItem(processType: number, name: string, propertyName: string, editorClassForName: string, editorPropertyName: string, returnClassForName: string, propertyDefaultValue: string): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.admin.ProcessPropertiesItem_addProcessPropertiesItem_Number_String_String_String_String_String_String", [processType, name, propertyName, editorClassForName, editorPropertyName, returnClassForName, propertyDefaultValue]);
    }

    public async getProcessPropertiesItemCatalog(processType: number, regexStr: string, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getProcessPropertiesItemCatalog_Number_String_Number_Number", [processType, regexStr, page, recordsPerPage]);
    }

    public async getProcessProperties(processType: number, reload: boolean): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.Map_getProcessProperties_Number_Boolean", [processType, reload]);
    }

}
